const initialState = {};

const LoadingStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_LOADING_STATUS': {
      return action.payload;
    }

    default:
      return state;
  }
};

export default LoadingStatusReducer;
